<template>
  <div
    id="sidebar-menu"
    class="d-flex sidebar-menu-container"
    :class="{
      'has-mobile-footer': isMobile,
      'sidebar-menu-container--br-locked': brSidebarLocked,
    }"
    :style="{ 'flex-direction': isMobile ? 'column' : 'column' }"
  >
    <BrSidebarLockOverlay :visible="brSidebarLocked" :pending="brSidebarGatePending" />
    <ul
      class="sidebar-links custom-scrollbar"
      id="myDIV"
      :class="{ 'sidebar-links--br-locked': brSidebarLocked }"
      :style="[layoutobject.split(' ').includes('horizontal-wrapper')  ? layout.settings.layout_type=='rtl'? {'  -right': margin+'px'} : {'margin-left': margin+'px'} :  { margin : '0px', 'margin-top' : '8px'}]">
      <li class="back-btn">
        <router-link to="/" custom v-slot="{ navigate }">
          <a href="javascript:void(0)" @click="redirectToInternalLink($event, navigate, '/')">
          <img class="img-fluid" src="../../assets/images/logo/EMP-logo.png" alt="" />
          </a>
        </router-link>
        <div class="mobile-back text-right">
          <span>Back</span><i class="fa fa-angle-right pl-2" aria-hidden="true"></i>
        </div>
      </li>
      <li v-for="(menuItem, index) in filteredMenuItems" :key="index"
        :class="{'active': menuItem.active, 'sidebar-main-title' : menuItem.type == 'headtitle'}" class="sidebar-list">
        <!-- link title -->
        <div v-if="menuItem.type == 'headtitle'">
          <h6 class="lan-1">{{ $t(menuItem.headTitle1) }}</h6>
          <p class="lan-2">{{ $t(menuItem.headTitle2) }}</p>
        </div>
        <!-- Sub -->
        
        <a href="javascript:void(0)" class="sidebar-link sidebar-title" 
          v-if="menuItem.type == 'sub'"
          @click="setNavActive(menuItem, index)">
          <feather :type="menuItem.icon" class="top"></feather>
          <span>
            {{ $t(menuItem.title) }}
          </span>
          
          <div class="according-menu" v-if="menuItem.children">
            <i class="fa fa-angle-right pull-right"></i>
          </div>
        </a>
        <!-- Link -->
        <router-link :to="menuItem.path" 
          v-if="menuItem.type == 'link'" 
          custom 
          v-slot="{isActive, navigate }"
          >
          <a href="javascript:void(0)" 
          @click="redirectToInternalLink($event, navigate, menuItem.path); hidesecondmenu()"
          class="sidebar-link sidebar-title" 
          v-bind:t_label="menuItem.t_label"
          :class="{'router-link-exact-active active': isActive}" router-link-exact-active exact
          >
            <feather v-if="menuItem.icon" :type="menuItem.icon" class="top"></feather>
            <img v-if="!menuItem.icon && menuItem.active_iconImg" 
              :src="(subIsActive(menuItem.parent) ? menuItem.active_iconImg : menuItem.nonactive_iconImg)" 
              class="menu-icon-img" />
            <span
              style="margin-right: 8px;"
              :class="brMenuStackClass(menuItem)"
            >
              <span
                v-if="shouldShowBrUnverifiedBadge(menuItem)"
                class="br-menu-label"
              >{{ $t(menuItem.title) }}</span>
              <template v-else>{{ $t(menuItem.title) }}</template>
              <span
                v-if="shouldShowBrUnverifiedBadge(menuItem)"
                class="new-badge br-unverified-badge"
              >{{ $t('lbl_EMPBE_BR_Sidebar_Unverified') }}</span>
            </span>
            <span
              class="badgeClass"
              :class="{ 'badgeClass--danger': menuItem.badgeType === 'light-danger' }"
              v-if="menuItem.badgeValue && menuItem.badgeType != 'danger'"
            >{{ menuItem.badgeValue === '!' ? '!' : $t(menuItem.badgeValue) }}</span>
            <img class="warn-badge" src="https://cdn.adsalecdn.com/EMP/Backend/svg/PublicTabs/warn.svg" alt="danger badge" v-if="menuItem.badgeType == 'danger'"/>
        
            <span class="badge badge-danger badge-pill d-inline p-1" v-if="menuItem.notification"></span>
            <i class="fa fa-angle-right pull-right" v-if="menuItem.children"></i>
          </a>
        </router-link>
        <!-- External Link :href="menuItem.path"  -->
        <a 
          href="javascript:void(0)"
          class="sidebar-link sidebar-title" 
          v-if="menuItem.type == 'extLink'"
          @click="setNavActive(menuItem, index)">
          <feather :type="menuItem.icon" class="top"></feather>
          <span>
            {{ $t(menuItem.title) }}
          </span>
          <i class="fa fa-angle-right pull-right" v-if="menuItem.children"></i>
        </a>
        <!-- External Tab Link -->
        <a
          :href="getExternalLink(menuItem)"
          target="_blank"
          class="sidebar-link sidebar-title"
          v-if="menuItem.type == 'extTabLink'"
          @click="onExternalTabLinkClick($event, menuItem)"
        >
          <feather v-if="menuItem.icon" :type="menuItem.icon" class="top"></feather>
          <img v-if="!menuItem.icon && menuItem.nonactive_iconImg" 
            :src="menuItem.nonactive_iconImg" 
            class="menu-icon-img" />
          <span>
            {{ $t(menuItem.title) }}
          </span>
          <i class="fa fa-angle-right pull-right" v-if="menuItem.children"></i>
        </a>
        <!-- 2nd Level Menu -->
        <ul class="sidebar-submenu" v-if="menuItem.children" :class="{ 'menu-open': menuItem.active }">
          <li v-for="(childrenItem, index) in menuItem.children" :key="index" :class="{'active': childrenItem.active}">
            <!-- Sub -->
            <a class="submenu-title" href="javascript:void(0)" v-if="childrenItem.type == 'sub'"
              @click="setNavActive(childrenItem, index)">
              {{ $t(childrenItem.title) }}
              <label :class="'badge badge-'+childrenItem.badgeType+' pull-right'"
                v-if="childrenItem.badgeType">{{childrenItem.badgeValue}}</label>
              <i class="fa pull-right mt-1"
                v-bind:class="[childrenItem.active ? 'fa fa-angle-down' : 'fa fa-angle-right']"
                v-if="childrenItem.children"></i>
            </a>
            <!-- Link -->
            <router-link :to="childrenItem.path" 
              v-if="childrenItem.type == 'link'" 
              custom v-slot="{ isActive, navigate }"
              >
              <a href="javascript:void(0)" 
              @click="redirectToInternalLink($event, navigate, childrenItem.path); hidesecondmenu()"
              class="submenu-title"
              v-bind:t_label="menuItem.t_label"
              :class="{'router-link-exact-active active': isActive}" router-link-exact-active exact
              >
                {{ $t(childrenItem.title) }}
                <label :class="'badge badge-'+childrenItem.badgeType+' pull-right'" v-if="childrenItem.badgeType">{{
                $t(childrenItem.badgeValue) }}</label>
                <i class="fa fa-angle-right pull-right mt-1" v-if="childrenItem.children"></i>
              </a>
            </router-link>
            <!-- External Link -->
            <a :href="childrenItem.path" v-if="childrenItem.type == 'extLink'" class="submenu-title">
              {{ $t(childrenItem.title) }}
              <label :class="'badge badge-'+childrenItem.badgeType+' pull-right'" v-if="childrenItem.badgeType">{{
              $t(childrenItem.badgeValue) }}</label>
              <i class="fa fa-angle-right pull-right mt-1" v-if="childrenItem.children"></i>
            </a>
            <!-- External Tab Link -->
            <a class="submenu-title" :href="getExternalLink(childrenItem)" target="_blank" v-if="childrenItem.type == 'extTabLink'">
              {{ $t(childrenItem.title) }}
              <label :class="'badge badge-'+childrenItem.badgeType+' pull-right'" v-if="childrenItem.badgeType">{{
              $t(childrenItem.badgeValue) }}</label>
              <i class="fa fa-angle-right pull-right mt-1" v-if="childrenItem.children"></i>
            </a>
            <!-- 3rd Level Menu -->
            <ul class="nav-sub-childmenu submenu-content" v-if="childrenItem.children"
              :class="{ 'opensubchild': childrenItem.active }">
              <li v-for="(childrenSubItem, index) in childrenItem.children" :key="index">
                <!-- Link -->
                <router-link :to="childrenSubItem.path" 
                  v-if="childrenSubItem.type == 'link'" 
                  custom v-slot="{ navigate }" 
                  >
                  <a href="javascript:void(0)" @click="redirectToInternalLink($event, navigate, childrenSubItem.path); hidesecondmenu()"
                  router-link-exact-active exact>
                  {{ $t(childrenSubItem.title) }}
                  <label :class="'badge badge-'+childrenSubItem.badgeType+' pull-right'"
                    v-if="childrenSubItem.badgeType">{{ $t(childrenSubItem.badgeValue) }}</label>
                  <i class="fa fa-angle-right pull-right" v-if="childrenSubItem.children"></i>
                  </a>
                </router-link>
                <!-- External Link -->
                <router-link :to="childrenSubItem.path" v-if="childrenSubItem.type == 'extLink'"
                   custom v-slot="{ navigate }" >

                  <a href="javascript:void(0)" @click="redirectToInternalLink($event, navigate, childrenSubItem.path)"
                  router-link-exact-active>

                  {{ $t(childrenSubItem.title) }}
                  <label :class="'badge badge-'+childrenSubItem.badgeType+' pull-right'"
                    v-if="childrenSubItem.badgeType">{{ $t(childrenSubItem.badgeValue) }}</label>
                  <i class="fa fa-angle-right pull-right" v-if="childrenSubItem.children"></i>

                  </a>
                </router-link>
              </li>
            </ul>
          </li>
        </ul>
      </li>
    </ul>
    
    <div class="sidebar-bottom-menu-separator"></div>
    <!-- Bottom Menu Items (Desktop & Mobile) -->
    <ul class="sidebar-bottom-menu" v-if="bottomMenuItemsItem && bottomMenuItemsItem.length > 0">
      <li v-for="(bottomItem, index) in bottomMenuItemsItem" :key="index"
        :class="{
          'active': subIsActive(bottomItem.parent),
          'sidebar-bottom-item--br-allowed': isBrBottomMenuAllowed(bottomItem),
        }"
        class="sidebar-bottom-item">
        <template v-if="bottomItem.TipsLin8 && (typeof bottomItem.TipsLin8 === 'string' ? bottomItem.TipsLin8.trim().length > 0 : bottomItem.TipsLin8.length > 0)">
          <el-tooltip
            effect="dark"
            placement="bottom"
            :value="false"
            :open-delay="200">
            <div slot="content" v-html="$t(bottomItem.TipsLin8)"></div>
            <router-link :to="bottomItem.path" 
            custom v-slot="{ isActive, navigate }"
            >
              <a href="javascript:void(0)" @click="redirectToInternalLink($event, navigate, bottomItem.path); hidesecondmenu()"
              class="sidebar-link sidebar-title"
              :class="{'router-link-exact-active active': isActive}"
              router-link-exact-active exact
              >
                <feather v-if="bottomItem.icon" :type="bottomItem.icon" class="top"></feather>
                <img v-if="!bottomItem.icon && bottomItem.active_iconImg" 
                  :src="(subIsActive(bottomItem.parent) ? bottomItem.active_iconImg : bottomItem.nonactive_iconImg)" 
                  class="menu-icon-img" />
                <span>
                  {{ $t(bottomItem.title) }}
                  <span v-if="bottomItem.isNew">
                    <span class="new-badge">{{$t("lbl_EMPBE_News")}}</span>
                  </span>
                </span>

              </a>
            </router-link>
          </el-tooltip>
        </template>
        <router-link
          v-else
          :to="bottomItem.path" 
          custom v-slot="{ isActive, navigate }"
          >

          <a href="javascript:void(0)" @click="redirectToInternalLink($event, navigate, bottomItem.path); hidesecondmenu()"
          class="sidebar-link sidebar-title"
          :class="{
            'router-link-exact-active active': isActive,
            'sidebar-link--br-unverified': shouldShowBrUnverifiedBadge(bottomItem),
          }"
          router-link-exact-active exact
          >

            <feather v-if="bottomItem.icon" :type="bottomItem.icon" class="top"></feather>
            <img v-if="!bottomItem.icon && bottomItem.active_iconImg" 
              :src="(subIsActive(bottomItem.parent) ? bottomItem.active_iconImg : bottomItem.nonactive_iconImg)" 
              class="menu-icon-img" />
            <span :class="brMenuStackClass(bottomItem)">
              <span
                v-if="shouldShowBrUnverifiedBadge(bottomItem)"
                class="br-menu-label"
              >{{ $t(bottomItem.title) }}</span>
              <template v-else>{{ $t(bottomItem.title) }}</template>
              <span
                v-if="shouldShowBrUnverifiedBadge(bottomItem)"
                class="new-badge br-unverified-badge"
              >{{ $t('lbl_EMPBE_BR_Sidebar_Unverified') }}</span>
              <span v-else-if="bottomItem.isNew" class="new-badge">{{ $t('lbl_EMPBE_News') }}</span>
            </span>


          </a>
          
        </router-link>
        <div class="sidebar-bottom-footer-tips-wrapper" v-if="!isSuperAdmin && bottomItem.title === 'lbl_EMPBE_MyUsers'">
          <div class="sidebar-tips-arrow"></div>
          <div class="sidebar-bottom-footer-tips">
            <div>
              {{$t('lbl_EMPBE_MyAccount_Tips')}}
            </div>
          </div>
        </div>
      </li>
    </ul>
    <!-- Mobile Footer Section: Logout and Language -->
    <div class="sidebar-mobile-footer" v-if="isMobile" :style="{ 'width': togglesidebar ? '330px' : '86px'}">
      <div class="sidebar-mobile-footer-content">
        <!-- Logout Button -->
        <div class="sidebar-mobile-logout" @click="handleLogout">
          <feather type="log-out" class="logout-icon" :size="18" stroke-width="2"></feather>
          <span>{{ $t("lbl_EMPBE_Logout") }}</span>
        </div>
        <!-- Language Selector -->
        <div class="sidebar-mobile-footer-separator"></div>
        <Language class="sidebar-mobile-language" variant="light" />
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import { layoutClasses } from '../../constants/layout';
import BrSidebarLockOverlay from '../../pages/businessDocuments/components/BrSidebarLockOverlay.vue';
import {
  shouldLockSidebarForBr,
  isKybAccessGatePending,
  brRuntimeState,
  isRouteKybExempt,
  isBrFeatureEnabled,
} from '../../constants/businessRegistration';
import { hasBrApprovedDisplayDocument } from '../../constants/brDocumentCore';
import Language from '../header/language.vue';

export default {
  name: 'Navmenu',
  components: {
    Language,
    BrSidebarLockOverlay,
  },
  data() {
    return {
      layoutobj: {},
      windowWidth: window.innerWidth,
    };
  },
  computed: {
    ...mapState({
      menuItems: state => state.menu.data,
      bottomMenuItems: state => state.menu.bottomMenuItems,
      layout: state => state.layout.layout,
      activeoverlay: (state) => state.menu.activeoverlay,
      togglesidebar: (state) => state.menu.togglesidebar,
      width: (state) => state.menu.width,
      margin: (state) => state.menu.margin,
      menuWidth: (state) => state.menu.menuWidth,
      user: (state) => state.authentication.user,
    }),
    bottomMenuItemsItem(){
      return this.bottomMenuItems.filter(item => {
        // 管理員不當作供應商開 BR：隱藏「商業文件」入口
        if (this.user && String(this.user.userType || '').toUpperCase() === 'ADMIN'
          && String(item.path || '').indexOf('/businessDocuments') === 0) {
          return false;
        }
        // 如果是超级管理员，隐藏 MyUsers 菜单项
        if (this.user && this.user.IsFullAccess === true && item.path === '/UserSetting/MyUsers') {
          return false;
        }
        if (!this.user || !this.user.userRole || !item.permissionType) {
          return false;
        }
        return item.permissionType.includes(this.user.userRole.toLowerCase());
      });
    },
    // 检查当前用户是否是超级管理员
    isSuperAdmin() {
      return this.user && this.user.IsFullAccess === true;
    },
    brSidebarLocked() {
      // 依赖响应式字段：gate / loading / 列表 / 加载时间
      void brRuntimeState.hasSubmitted;
      void brRuntimeState.kybGate;
      void brRuntimeState.kybGateLoading;
      void brRuntimeState.dataLoadedAt;
      void (brRuntimeState.documentList || []).length;
      return shouldLockSidebarForBr(this.user);
    },
    /** AccessGate 冷启动确认中：侧栏挡住菜单，文案用「确认中」而非完整锁定说明 */
    brSidebarGatePending() {
      void brRuntimeState.kybGateLoading;
      void brRuntimeState.kybGate;
      return isKybAccessGatePending();
    },
    /** 无「已审批 / 已审批及已生效 / 已审批(待生效)」时显示侧栏未認証标签 */
    showBrUnverifiedBadge() {
      void brRuntimeState.dataLoadedAt;
      void (brRuntimeState.documentList || []).length;
      if (!isBrFeatureEnabled()) {
        return false;
      }
      // 列表未加载完不展示，避免已认证用户闪一下「未認証」
      if (!brRuntimeState.dataLoadedAt) {
        return false;
      }
      return !hasBrApprovedDisplayDocument(brRuntimeState.documentList || []);
    },
    layoutobject: {
      get: function () {
        return JSON.parse(JSON.stringify(layoutClasses.find((item) => Object.keys(item).pop() === this.layout.settings.layout)))[this.layout.settings.layout];
      },
      set: function () {
        this.layoutobj = layoutClasses.find((item) => Object.keys(item).pop() === this.layout.settings.layout);
        this.layoutobj = JSON.parse(JSON.stringify(this.layoutobj))[this.layout.settings.layout];
        return this.layoutobj;
      }
    },
    isMobile() {
      return this.windowWidth < 991;
    },
    filteredMenuItems() {
      // Always return a new array reference to ensure reactivity
      if (!this.isMobile) {
        // Desktop: show all menu items
        return this.menuItems || [];
      }
      // Mobile: filter menu items based on showOnMobile property
      // Only show items where showOnMobile === true
      const filtered = this.filterMenuItemsByMobile(this.menuItems || []);
      // Figma 手机侧栏：Business Documents 进主列表（桌面仍用底部 bottomMenu）
      // 仅注入 BR，复用电脑版图标 / 权限过滤；不带出 MyUsers 等其它底部项
      const brMobileEntries = (this.bottomMenuItemsItem || []).filter((item) => (
        String(item.path || '').indexOf('/businessDocuments') === 0
      ));
      if (!brMobileEntries.length) {
        return filtered;
      }
      const alreadyInMain = filtered.some((item) => (
        String(item.path || '').indexOf('/businessDocuments') === 0
      ));
      if (alreadyInMain) {
        return filtered;
      }
      return filtered.concat(brMobileEntries);
    }
  },
  watch: {
    width() {
      window.addEventListener('resize', this.handleResize);
      this.handleResize();
      window.addEventListener('scroll', this.handleScroll);
      this.handleScroll();
      if (window.innerWidth < 992) {
        const newlayout = JSON.parse(JSON.stringify(this.layoutobject).replace('horizontal-wrapper', 'compact-wrapper'));
        document.querySelector('.page-wrapper').className = 'page-wrapper ' + newlayout;
        this.$store.state.menu.margin = 0;
      } else {
        document.querySelector('.page-wrapper').className = 'page-wrapper ' + this.layoutobject;
      }

      if ((window.innerWidth < 1199 && this.layout.settings.layout === 'Tokyo') || (window.innerWidth < 1199 && this.layout.settings.layout === 'Moscow') || (window.innerWidth < 1199 && this.layout.settings.layout === 'Rome')) {
        this.menuItems.filter(menuItem => {
          menuItem.active = false;
        });
      }
    },
    menuItems: {
      handler() {
        // Force reactivity update when menu items change
        this.$forceUpdate();
      },
      deep: true
    }
  },
  created() {
    this.windowWidth = window.innerWidth;
    window.addEventListener('resize', this.handleResize);
    this.handleResize();
    if (this.$store.state.menu.width < 991) {
      this.layout.settings.layout = 'Dubai';
      this.$store.state.menu.margin = 0;
    }
    setTimeout(() => {
      const elmnt = document.getElementById('myDIV');
      this.$store.state.menu.menuWidth = elmnt.offsetWidth;
      this.$store.state.menu.menuWidth > window.innerWidth ?
        (this.$store.state.menu.hideRightArrow = false, this.$store.state.menu.hideLeftArrowRTL = false) :
        (this.$store.state.menu.hideRightArrow = false, this.$store.state.menu.hideLeftArrowRTL = true);
    }, 500);
    this.layoutobject = layoutClasses.find((item) => Object.keys(item).pop() === this.layout.settings.layout);
    this.layoutobject = JSON.parse(JSON.stringify(this.layoutobject))[this.layout.settings.layout];
  },
  destroyed() {
    window.removeEventListener('resize', this.handleResize);
  },
  mounted() {
    // Ensure windowWidth is set on mount
    this.windowWidth = window.innerWidth;
    
    this.menuItems.filter(items => {
      if (items.path === this.$route.path)
        this.$store.dispatch('menu/setActiveRoute', items);
      if (!items.children) return false;
      items.children.filter(subItems => {
        if (subItems.path === this.$route.path)
          this.$store.dispatch('menu/setActiveRoute', subItems);
        if (!subItems.children) return false;
        subItems.children.filter(subSubItems => {
          if (subSubItems.path === this.$route.path)
            this.$store.dispatch('menu/setActiveRoute', subSubItems);
        });
      });
    });
  },
  methods: {
    handleScroll() {
      if (window.scrollY > 400) {
        if (this.layoutobject.split(' ').pop() === 'material-type' || this.layoutobject.split(' ').pop() === 'advance-layout')
          document.querySelector('.sidebar-main').className = 'sidebar-main hovered';
      } else {
        if (document.getElementById('sidebar-main'))
          document.querySelector('.sidebar-main').className = 'sidebar-main';
      }
    },
    setNavActive(item, index) {
      this.$store.dispatch('menu/setNavActive', item);
      if (this.layoutobject.split(' ').includes('compact-sidebar') && window.innerWidth > 991) {
        if (this.menuItems.some(menuItem => menuItem.active === true)) {
          this.$store.state.menu.activeoverlay = true;
        } else {
          this.$store.state.menu.activeoverlay = false;
        }
      }
    },
    hidesecondmenu() {
      if (window.innerWidth < 991) {
        this.$store.state.menu.activeoverlay = false,
          this.$store.state.menu.togglesidebar = false;
        this.menuItems.filter(menuItem => {
          menuItem.active = false;
        });
      } else if (this.layoutobject.split(' ').includes('compact-sidebar')) {
        this.$store.state.menu.activeoverlay = false,
          this.menuItems.filter(menuItem => {
            menuItem.active = false;
          });
      }
    },
    handleResize() {
      this.windowWidth = window.innerWidth;
      this.$store.state.menu.width = window.innerWidth - 450;
    },
    subIsActive(input) {
      const paths = Array.isArray(input) ? input : [input]
      return paths.some(path => {
        return this.$route.path.indexOf(path) === 0 // current path starts with this path string
      })
    },
    redirectToInternalLink(event, navigate, targetPath = '') {
      if (this.brSidebarLocked && !isRouteKybExempt({ path: targetPath })) {
        event.preventDefault();
        event.stopImmediatePropagation();
        return;
      }
      navigate(event);
    },
    isBrBottomMenuAllowed(bottomItem) {
      if (!this.brSidebarLocked) {
        return true;
      }
      return isRouteKybExempt({ path: bottomItem?.path });
    },
    isBusinessDocumentsMenuItem(item) {
      return String(item?.path || '').indexOf('/businessDocuments') === 0;
    },
    shouldShowBrUnverifiedBadge(item) {
      return this.showBrUnverifiedBadge && this.isBusinessDocumentsMenuItem(item);
    },
    /** 英文标题较长：标题独占一行、黄标签换行；中文短：同一行 */
    isBrMenuEnglishLocale() {
      return (this.$i18n && this.$i18n.locale) === 'en';
    },
    brMenuStackClass(item) {
      if (!this.shouldShowBrUnverifiedBadge(item)) {
        return null;
      }
      return {
        'br-menu-stack': true,
        'br-menu-stack--en': this.isBrMenuEnglishLocale(),
      };
    },
    onExternalTabLinkClick(event, menuItem) {
      event.preventDefault();
      const url = this.getExternalLink(menuItem);
      if (url && url !== '#') {
        window.open(url, '_blank');
      }
    },
    getExternalLink(menuItem) {
      if (!menuItem.path) return '#';
      
      // 对于"采购墙"，使用与"查看所有采购需求"相同的链接格式
      const pathSegments = menuItem.path.split('/').filter(s => s);
      const lastSegment = pathSegments[pathSegments.length - 1];
      
      if (lastSegment === 'BuyerRequestSearchSupplier' && this.user && this.user.token) {
        // 使用SupplierToken路由，格式与"查看所有采购需求"保持一致
        // 格式：https://www.chinaplasonline.com/eMarketplace/SupplierToken/{lang}?TargetPage=sourcingrequest&SupplierToken={token}
        const origin ="https://www.chinaplasonline.com";
        const lang = localStorage.getItem("currentLang") || "simp";
        return `${origin}/eMarketplace/SupplierToken/${lang}?TargetPage=sourcingrequest&SupplierToken=${this.user.token}`;
      }
      
      // 对于其他所有 extTabLink，直接返回原始 path（不做任何处理）
      return menuItem.path;
    },
    filterMenuItemsByMobile(menuItems) {
      if (!Array.isArray(menuItems) || menuItems.length === 0) {
        return [];
      }
      
      return menuItems
        .filter(menuItem => {
          // Only show items with showOnMobile: true on mobile
          // If showOnMobile is undefined or false, hide it
          return menuItem.showOnMobile === true;
        })
        .map(menuItem => {
          // Create a deep copy to avoid mutating original data
          const cloned = JSON.parse(JSON.stringify(menuItem));
          
          // If it has children, recursively filter children
          if (cloned.children && Array.isArray(cloned.children) && cloned.children.length > 0) {
            cloned.children = this.filterMenuItemsByMobile(cloned.children);
          }
          
          return cloned;
        });
    },
    handleLogout() {
      this.$store.dispatch('authentication/logout');
    },
  }
};
</script>
<style scoped>
.badgeClass{
  color: #fff !important;
  font-size: 12px;
  font-weight: 500;
  line-height: 20px;
  border-radius: 125px;
  background:  #7366FF;
  display: inline-flex;
  box-sizing: border-box;
  height: 20px;
  min-width: 20px;
  max-width: 42.5px;
  padding: 0 4px;
  justify-content: center;
  align-items: center;
}
.badgeClass--danger {
  background: #CD1515;
}
.badge{
  right: 24px!important;
}
.badge-danger{
  border-radius: 50% !important;
}
.sidebar-links.custom-scrollbar {
  /* padding-bottom: 40px !important;
  flex: 1; */
  overflow-y: auto;
  overflow-x: hidden;
}

.menu-icon-img {
  width: 20px;
  height: 20px;
  object-fit: contain;
}

#sidebar-menu.has-mobile-footer {
  position: relative;
  min-height: 100%;
  padding-bottom: 80px;
}

.sidebar-bottom-footer-tips-wrapper {
  position: relative;
  width: 100%;
  padding: 0 8px;
  margin-top: 8px;
}

.sidebar-tips-arrow {
  position: absolute;
  bottom: 100%;
  left: 50%;
  transform: translateX(-50%);
  width: 0;
  height: 0;
  border-left: 8px solid transparent;
  border-right: 8px solid transparent;
  border-bottom: 8px solid rgba(0, 0, 0, 0.80);
  pointer-events: none;
  z-index: 10;
}

.sidebar-bottom-footer-tips div{

  background: rgba(0, 0, 0, 0.80);
  color: white;   
  font-size: 12px;
    font-weight: 400;
    line-height: 15.60px;
    word-wrap: break-word;
    border-radius: 4px; 
 
  padding: 8px; 
}
.sidebar-bottom-footer-tips{
    position: relative;
    display: block;
    width: 100%;
 
    padding: 0 8px;
    
}

/* Mobile Footer Section */
.sidebar-mobile-footer {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: #ffffff;
  padding-bottom: 16px;
  /* 高于 .sidebar-links(z-index:99)，避免语言下拉被菜单层挡住点击 */
  z-index: 120;
  margin-top: auto;
  font-size: 14px;
  font-family: Roboto;
  width: 330px;
  transition: all 0.3s ease;
}

.sidebar-mobile-footer ::v-deep .dropdown-menu {
  z-index: 121;
}

.sidebar-mobile-footer-separator {
  height: 1px;
  background-color: #e5e5e5;
  margin-bottom: 8px;
  transition: all 0.1s ease;
  
}

.sidebar-mobile-footer-content {
  display: flex;
  flex-direction: column;
  padding: 0 8px;
  gap: 0;

}

.sidebar-mobile-logout {
  display: flex;
  align-items: center;
  padding: 16px 16px;
  cursor: pointer;
  transition: all 0.3s ease;
  font-size: 14px;
  color: #222222;
  user-select: none;
  background: none;
  border: none;
  width: 100%;
  text-align: left;
  position: relative;
  margin-bottom: 8px;
}

.sidebar-mobile-logout .logout-icon {
  display: inline-block;
  flex-shrink: 0;
  margin-right: 10px;
  vertical-align: bottom;
}

/* Use deep selector to target SVG inside feather component */
.sidebar-mobile-logout ::v-deep svg {
  width: 18px;
  height: 18px;
  margin-right: 10px;
  stroke-width: 2px;
  stroke: #222222;
  color: #222222;
  transition: all 0.3s ease;
}

.sidebar-mobile-logout span {
  font-weight: 500;
  color: #222222;
  transition: all 0.3s ease;
}

.sidebar-mobile-language {
  width: 100%;
  display: block;
  margin-left: 0 !important;
  padding: 0px 12px;
}



.sidebar-mobile-language .translate_wrapper {
  width: 100%;
  margin-left: 0;
  height: auto;
}

.sidebar-mobile-language .translate_wrapper .language-button {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 12px 15px;
  border: none;
  border-radius: 0;
  background-color: transparent;
  cursor: pointer;
  margin: 0;
  color: #222222;
  transition: all 0.3s ease;
  position: relative;
}

.sidebar-mobile-language .translate_wrapper .language-button i.icon-world {
  margin-right: 10px;
  font-size: 18px;
  color: #222222;
  transition: all 0.3s ease;
}

.sidebar-mobile-language .translate_wrapper .language-button .name {
  flex: 1;
  text-align: left;
  font-size: 14px;
  font-weight: 500;
  color: #222222;
  transition: all 0.3s ease;
  
}

.sidebar-mobile-language .translate_wrapper .language-button .fa-sort-down {
  margin-left: auto;
  color: #222222;
  transition: all 0.3s ease;
}

/* Sidebar Menu Container */
.sidebar-menu-container {
  position: relative;
  flex-direction: column;
  height: 100%;
  display: flex;
}

.sidebar-menu-container--br-locked {
  flex: 1;
  min-height: calc(100vh - 101px);
}

.sidebar-menu-container--br-locked .sidebar-bottom-footer-tips-wrapper,
.sidebar-menu-container--br-locked .sidebar-mobile-footer,
.sidebar-menu-container--br-locked .sidebar-bottom-menu {
  user-select: none;
  opacity: 0.35;
}

.sidebar-links--br-locked {
  user-select: none;
  opacity: 0.35;
  pointer-events: none;
}

.sidebar-menu-container--br-locked .sidebar-bottom-menu .sidebar-bottom-item:not(.sidebar-bottom-item--br-allowed) {
  pointer-events: none;
}

/* Bottom Menu Items */
.sidebar-bottom-menu {
  list-style: none;
  padding: 0;
  margin: 0;
  /* margin-top: auto; */
  /* border-top: 1px solid #e5e5e5; */
  padding-top: 8px;
  flex-shrink: 0;
}
.sidebar-bottom-menu-separator{
  height: 1px;
   background: rgba(0, 0, 0, 0.05);
    margin:16px 0px;
}
.new-badge{
  padding: 6px;
  border-radius: 25px;
  background: #FFD02C;
  color: rgba(0, 0, 0, 0.80) !important;
  font-size: 12px !important;
  font-weight: 600;
  line-height: 18px;
  word-wrap: break-word
  
}
/*
 * 未认证黄标签：附加元素，不改标题字号 / 菜单行 padding。
 * height:20px / line-height:12px 只作用于本黄标签，不影响其它 .new-badge。
 * 中文：标题+标签同一行，标签不撑高背景（与「用户管理」行高一致）；
 * 英文：标题独占一行，标签在下一行。
 */
.sidebar-bottom-item .sidebar-link .new-badge.br-unverified-badge,
.sidebar-links .new-badge.br-unverified-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto !important;
  box-sizing: border-box;
  width: auto;
  max-width: max-content;
  height: 20px;
  margin-left: 4px;
  padding: 0 6px !important;
  line-height: 12px;
  letter-spacing: 0 !important;
  text-transform: none !important;
}
.sidebar-bottom-item .sidebar-link .br-menu-stack,
.sidebar-links .br-menu-stack {
  flex: 0 1 auto !important;
  width: auto;
  max-width: 100%;
}
.sidebar-bottom-item .sidebar-link .br-menu-stack .br-menu-label,
.sidebar-links .br-menu-stack .br-menu-label {
  flex: 0 1 auto !important;
  width: auto;
  max-width: 100%;
}
/* 中文：标签脱离文档流，不增加菜单行高度，紫底与普通项一致 */
.sidebar-bottom-item .sidebar-link .br-menu-stack:not(.br-menu-stack--en),
.sidebar-links .br-menu-stack:not(.br-menu-stack--en) {
  position: relative;
  display: inline-block !important;
  vertical-align: middle;
  /* 给右侧黄标签留出宽度，避免贴边裁切；不增加行高 */
  padding-right: 52px;
}
.sidebar-bottom-item .sidebar-link .br-menu-stack:not(.br-menu-stack--en) .br-unverified-badge,
.sidebar-links .br-menu-stack:not(.br-menu-stack--en) .br-unverified-badge {
  position: absolute;
  left: auto;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  margin-left: 0;
}
/* 英文：标题与黄标签上下排列，标题不再被标签挤断 */
.sidebar-bottom-item .sidebar-link .br-menu-stack--en,
.sidebar-links .br-menu-stack--en {
  display: flex !important;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  gap: 2px;
  white-space: normal !important;
}
.sidebar-bottom-item .sidebar-link .br-menu-stack--en .br-menu-label,
.sidebar-links .br-menu-stack--en .br-menu-label {
  white-space: nowrap;
}
.sidebar-bottom-item .sidebar-link .br-menu-stack--en .br-unverified-badge,
.sidebar-links .br-menu-stack--en .br-unverified-badge {
  position: static;
  transform: none;
  margin-left: 0;
}
.sidebar-bottom-item {
  margin: 0;
  padding: 0 8px;
  margin-bottom: 8px;
  position: relative;
  display: block;
  width: 100%;
}

.sidebar-bottom-item .sidebar-link {
  display: flex;
  align-items: center;
  padding: 8px 16px;
  color: #222222;
  text-decoration: none;
  transition: all 0.5s ease;
  border-radius: 8px;
  position: relative;
  min-height: 40px;
  font-weight: 500;
}

.sidebar-bottom-item .sidebar-link:hover {
  background-color: #f1f0ff;
  transition: all 0.3s ease;
}

.sidebar-bottom-item .sidebar-link:hover span {
  color: #7366FF;
  transition: all 0.3s ease;
}

.sidebar-bottom-item .sidebar-link:hover svg {
  stroke: #7366FF;
  transition: all 0.3s ease;
}

.sidebar-bottom-item.active .sidebar-link,
.sidebar-bottom-item .sidebar-link.router-link-exact-active {
  background-color: #dad6ff;
  transition: all 0.5s ease;
  position: relative;
}

.sidebar-bottom-item.active .sidebar-link span,
.sidebar-bottom-item .sidebar-link.router-link-exact-active span {
  color: #7366FF;
  transition: all 0.3s ease;
}

.sidebar-bottom-item.active .sidebar-link svg,
.sidebar-bottom-item .sidebar-link.router-link-exact-active svg {
  color: #7366FF;
  stroke: #7366FF;
  transition: all 0.3s ease;
}

.sidebar-bottom-item .sidebar-link .top {
  width: 18px;
  height: 18px;
  margin-right: 10px;
  flex-shrink: 0;
  vertical-align: bottom;
  float: none;
  stroke-width: 2px;
  color: #222222;
  transition: all 0.3s ease;
}

.sidebar-bottom-item .sidebar-link .menu-icon-img {
  width: 20px;
  height: 20px;
  margin-right: 10px;
  flex-shrink: 0;
}

.sidebar-bottom-item.active .sidebar-link .menu-icon-img,
.sidebar-bottom-item .sidebar-link.router-link-exact-active .menu-icon-img {
  filter: brightness(0) saturate(100%) invert(38%) sepia(93%) saturate(2045%) hue-rotate(227deg) brightness(100%) contrast(103%);
}

.sidebar-bottom-item .sidebar-link:hover .menu-icon-img {
  filter: brightness(0) saturate(100%) invert(38%) sepia(93%) saturate(2045%) hue-rotate(227deg) brightness(100%) contrast(103%);
}

.sidebar-bottom-item .sidebar-link span {
  font-size: 14px;
  font-weight: 500;
  flex: 1;
  letter-spacing: 0.7px;
  font-family: Roboto;
  text-transform: capitalize;
  color: #222222;
  white-space: nowrap;
  transition: all 0.3s ease;
}

/* Mobile adjustments for bottom menu */
@media (max-width: 991px) {
  .sidebar-bottom-menu {
    display: none;
  }
  .sidebar-bottom-footer-tips-wrapper {
    display: none !important;
  }
}

</style>
